// Import Theme Styles
import "../scss/style.scss";

import { initStickyHeaderEmu } from "./parts/header/stickyHeaderEmu";

import { initPromoBannerParallax } from "./partials/PageContent/promoBannerParallax";
import { initHomeCarousel } from "./partials/PageContent/homeCarousel";
import { initCategoryShowcase } from "./partials/PageContent/categoryShowcase";

const bootTheme = () => {
  console.log("[Client Theme] Initialized.");

  initStickyHeaderEmu();

  // Initialize the new parallax effect
  initPromoBannerParallax();
  initHomeCarousel();
  initCategoryShowcase(); // Call the initializer
};

if (window.EcommerceCore) {
  bootTheme();
} else {
  window.addEventListener("ecommerce_core_ready", bootTheme);
}
